import request from './index'

export function queryCurrentGuides(params) {
  return request({ url: '/consume/operationGuide/current', method: 'get', params })
}

export function queryAllGuides(params) {
  return request({ url: '/consume/operationGuide/list', method: 'get', params })
}

export function queryGuideDetail(params) {
  return request({ url: '/consume/operationGuide/detail', method: 'get', params })
}

export function queryGuideQaCapabilities(params) {
  return request({ url: '/consume/operationGuide/qa/capabilities', method: 'get', params, operationGuideAi: true })
}

export function askGuideQuestion(data) {
  return request({ url: '/consume/operationGuide/qa/ask', method: 'post', data, timeout: 95000, operationGuideAi: true })
}

export function guideQaData(res) {
  if (!res || String(res.resultCode) !== '200' || !res.resultData || typeof res.resultData !== 'object' || Array.isArray(res.resultData)) {
    const error = new Error('问答服务暂不可用')
    error.code = String(res && res.resultCode || (typeof res === 'string' || typeof res === 'number' ? res : ''))
    throw error
  }
  return res.resultData
}

export function guideQaErrorMessage(error) {
  const code = String(error && error.code || '')
  if (code === '409') return '操作指引或全局模型配置已更新，请重新提问以获取最新内容。'
  if (code === '401' || code === '403') return '登录状态或访问权限已变化，请重新登录或联系管理员。'
  if (code === '429') return '当前请求较多或上一项智能任务尚未结束，请稍后重试。'
  if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') return '问答请求超时，请稍后重试，或直接查看操作指引。'
  return '问答暂未完成，请稍后重试，或切换到“操作指引”直接查看。'
}
